export default __webpack_public_path__ + "static/frase1-cb59fdfa5c097c5da0c7395524c82fb8.png";